import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Metrics from '@spotahome/soyuz-tracking';

const hasEventTracking = tracking =>
  Object.values(tracking).filter(eventType => eventType).length;

// TODO: Remove once all usages of <Checkbox> have been
// updated to use soyuz-metrics for tracking instead of the class
// implementation.
const getClassNameUsingTracking = tracking => `checkbox__input ${tracking}`;

class FormCheckBox extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    labelTitle: PropTypes.string,
    checked: PropTypes.bool,
    tracking: PropTypes.string,
    soyuzTracking: PropTypes.shape({
      eventCategory: PropTypes.string,
      eventAction: PropTypes.string,
      eventLabel: PropTypes.string,
      eventValue: PropTypes.string
    }),
    onChange: PropTypes.func.isRequired,
    cy: PropTypes.string,
    dataTest: PropTypes.string
  };

  static defaultProps = {
    checked: false,
    tracking: null,
    soyuzTracking: {
      eventCategory: null,
      eventAction: null,
      eventLabel: null,
      eventValue: null
    },
    cy: null,
    labelTitle: '',
    dataTest: ''
  };

  state = {
    isChecked: !!this.props.checked
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isChecked !== this.props.checked) {
      this.updateIsChecked();
    }
  }

  updateIsChecked() {
    const { checked } = this.props;

    this.setState({ isChecked: checked });
  }

  handleClick = () => {
    const { soyuzTracking, onChange } = this.props;

    this.setState(
      state => ({ isChecked: !state.isChecked }),
      () => onChange(this.state.isChecked)
    );

    if (!this.state.isChecked && hasEventTracking(soyuzTracking)) {
      this.trackEvent(soyuzTracking);
    }
  };

  trackEvent = (...eventTypes) => {
    Metrics.ga.sendEvent(...Object.values(...eventTypes));
  };

  render() {
    const { tracking, id, cy, labelTitle, label, dataTest } = this.props;
    return (
      <div className="checkbox">
        <input
          className={getClassNameUsingTracking(tracking)}
          type="checkbox"
          id={id}
          data-cy={cy}
          onChange={this.handleClick}
          checked={this.state.isChecked}
          data-test={dataTest}
        />
        <label className="checkbox__label" htmlFor={id}>
          {labelTitle && (
            <>
              <span className="checkbox__label__title">{labelTitle}</span>
              <span> - </span>
            </>
          )}
          {label}
        </label>
      </div>
    );
  }
}

export default FormCheckBox;
